import { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { getToken } from '@/utils/auth';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const EditGameDialog = ({ game, onClose, onSaved }) => {
  const [editingGame, setEditingGame] = useState(game);
  const [loading, setLoading] = useState(false);

  const updateGame = async () => {
    setLoading(true);
    try {
      const token = getToken();
      await axios.put(`${API}/admin/games/${editingGame.id}`, editingGame, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Game updated successfully!');
      onSaved();
      onClose();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update game');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={!!game} onOpenChange={onClose}>
      <DialogContent className="border-[#E4E4E7]">
        <DialogTitle>Edit Game</DialogTitle>
        <DialogDescription>Update game information</DialogDescription>
        <div className="space-y-4 mt-4">
          <div>
            <Label>Name</Label>
            <Input value={editingGame.name} onChange={(e) => setEditingGame({...editingGame, name: e.target.value})} />
          </div>
          <div>
            <Label>Genre</Label>
            <Input value={editingGame.genre} onChange={(e) => setEditingGame({...editingGame, genre: e.target.value})} />
          </div>
          <div>
            <Label>Image URL</Label>
            <Input value={editingGame.image} onChange={(e) => setEditingGame({...editingGame, image: e.target.value})} />
          </div>
          <div>
            <Label>Description</Label>
            <Textarea value={editingGame.description} onChange={(e) => setEditingGame({...editingGame, description: e.target.value})} />
          </div>
          <div className="flex gap-2">
            <Button onClick={updateGame} disabled={loading} className="bg-[#0047FF]">Save</Button>
            <Button variant="outline" onClick={onClose}>Cancel</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
